<template>
  <el-input-localized-numeric
    v-model="price"
    :disabled="disabled"
    size="small"
    @change="onNetPriceChange"
  />
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    netPrice: {
      type: Number,
      default() {
        return 0;
      },
      required: false,
    },
    currency: {
      type: String,
      default() {
        return 'HUF';
      },
      required: false,
    },
    minNetPrice: {
      type: Number,
      default() {
        return 0;
      },
      required: false,
    },
  },
  data() {
    return {
      price: 0,
    };
  },
  watch: {
    netPrice(price) {
      this.price = price;
    },
  },
  mounted() {
    this.price = this.netPrice;
  },
  methods: {
    onNetPriceChange(price) {
      this.$emit('change', price);
    },
  },
};
</script>
